/* eslint-disable import/no-extraneous-dependencies */
import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import VueFeather from 'vue-feather';
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import Buefy from 'buefy';
import VCalendar from 'v-calendar';
import axios from 'axios';
import vueDebounce from 'vue-debounce';

import 'animate.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faLightbulb,
	faCoffee,
	faUserAstronaut,
	faUserFriends,
	faPoll,
	faUserClock,
	faBed,
	faUserPlus,
	faClock,
	faUndoAlt,
	faTimesCircle,
	faBoxes,
	faPeopleCarry,
	faCogs,
	faPallet,
	faTruckLoading,
	faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Toast from 'vue-toastification';
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css';
import store from './store';
import App from './App';
import router from './router';

const options = {
	// You can set your default options here
};
Vue.use(Toast, options);

library.add(
	faUserPlus,
	faCoffee,
	faUserAstronaut,
	faLightbulb,
	faUserFriends,
	faPoll,
	faClock,
	faLightbulb,
	faUserClock,
	faBed,
	faBoxes,
	faUndoAlt,
	faTimesCircle,
	faPeopleCarry,
	faCogs,
	faPallet,
	faTruckLoading,
	faExclamationTriangle
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(vueDebounce, {
	listenTo: ['input', 'keyup'],
});

Vue.use(Buefy);
Vue.use(VueFeather);
Vue.config.productionTip = false;
Vue.use(VCalendar);

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');

Vue.prototype.$http = axios;
const token = localStorage.getItem('token');
if (token) {
	Vue.prototype.$http.defaults.headers.common.Authorization = token;
}

